/*
 * Created by guandong.ni on 17/10/27.
 * jquery.ajax 2+  封装
 */
import loading from './loading.jquery';
import toast from './toast.jquery';
export function get(url, param, isShowLoading) {
  let p = Object.assign({}, param);
  p.method = 'GET';
  p.url = url;
  p.isShowLoading = !!isShowLoading;
  return send(p);
}
export function post(url, param, isShowLoading) {
  let p = Object.assign({}, param);
  p.method = 'POST';
  p.url = url;
  p.isShowLoading = !!isShowLoading;
  return send(p);
}
export function send(param) {
  let settings = Object.assign({
    url: '',
    method: 'GET',
  }, param);
  return new Promise((resolve, reject) => {
    'use strict';
    if (!settings.url) {
      toast('url地址错误');
      reject();
    }
    settings.complete = () => {
      if (param.complete) {
        param.complete.call();
      }
      if (!param.isShowLoading) {
        loading.hide();
      }

    };
    settings.success = (data) => {
      if (param.success) {
        param.success.call(window, data);
      }
      resolve(data);
    };
    settings.error = (a, b, c) => {
      if (param.error) {
        param.error.call(window, a, b, c);
      }
      reject(a, b, c);
    };
    if (!param.isShowLoading) {
      loading.show();
    }
    $.ajax(settings);
  });
}
export function jsonp(options) {
  'use strict';
  options = options || {};
  if (!options.url || !options.callback) {
    throw new Error('参数不合法');
  }

  //创建 script 标签并加入到页面中
  var callbackName = '_cb_';
  // var callbackName = ('jsonp_' + Math.random()).replace(".", "");
  var head = document.getElementsByTagName('head')[0];
  options.data[options.callback] = callbackName;
  var params = formatParams(options.data);
  var script = document.createElement('script');
  head.appendChild(script);

  //创建jsonp回调函数
  window[callbackName] = function(json) {
    head.removeChild(script);
    clearTimeout(script.timer);
    window[callbackName] = null;
    options.success(json);
  };

  //发送请求
  script.src = options.url + '?' + params;

  //超时处理
  if (options.timeout) {
    script.timer = setTimeout(function() {
      window[callbackName] = function() {
      };
      head.removeChild(script);
      options.fail && options.fail({message: '超时'});
    }, options.timeout);
  }
}
export default {
  get,
  post,
  send,
};



// WEBPACK FOOTER //
// ./src/component/common/ajax.jquery.js